import "@hotwired/turbo-rails"
import { application } from "../controllers/application.js"

import "quill/dist/quill.snow.css"

import NavigationMenuController from "../controllers/navigation_menu_controller"
application.register("navigation-menu", NavigationMenuController)

import AvailablePackagesController from "../controllers/available_packages_controller"
application.register("available-packages", AvailablePackagesController)

import PackagePickerController from "../controllers/package_picker_controller"
application.register("package-picker", PackagePickerController)

import LakhanaCalculatorController from "../controllers/lakhana_calculator_controller"
application.register("lakhana-calculator", LakhanaCalculatorController)

import ScrollRowController from "../controllers/scroll_row_controller"
application.register("scroll-row", ScrollRowController)

import TodaysSkyController from "../controllers/todays_sky_controller"
application.register("todays-sky", TodaysSkyController)

import CardPickController from "../controllers/card_pick_controller"
application.register("card-pick", CardPickController)

// landing v2: สไลด์/แท็บย่อความยาวหน้าบนมือถือ
import LvSwipeController from "../controllers/lv_swipe_controller"
application.register("lv-swipe", LvSwipeController)

import LvTabsController from "../controllers/lv_tabs_controller"
application.register("lv-tabs", LvTabsController)

import LvReelController from "../controllers/lv_reel_controller"
application.register("lv-reel", LvReelController)

import "../src/landing/past_works.js"
import "../src/landing/services.js"
import "../src/landing/scroll_hint.js"
